// src/pages/packages/CreatePackage.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditPackage from "../../components/packages/FormAddEditPackage";

const CreatePackage = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/packages");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPackage
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreatePackage;
